import React from 'react'
import { func, string } from 'prop-types'
import Icon from 'components/uiElements/Icon'

require('./BackNavigationHeader.scss')

const BackNavigationHeader = ({ onClick, navigationText }) => (
    <div className="BackNavigation">
        <button onClick={onClick}>
            <span className="backIcon">
                <Icon code="arrowLeft" />
            </span>
            <span className="backText">{navigationText}</span>
        </button>
    </div>
)

BackNavigationHeader.propTypes = {
    onClick: func.isRequired,
    navigationText: string.isRequired,
}
export default BackNavigationHeader
